import React from 'react'
import {connect, store} from 'react-redux'
import {instanceOf} from 'prop-types';
import moment from 'moment';
import {Route, Switch} from 'react-router'
import 'moment/locale/ja';
import {Redirect} from 'react-router-dom'
import NotFound from "./components/NotFound";
import MapLoader from "./containers/map/MapLoader";

moment.locale('ja');


const mapStateToProps = (state, props) => {
    return {
        session: state.session,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        doLogout() {
        },
        checkLoggedIn: () => {
        }
    }
};

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            session: props.session,
            currentStep: 0,
            searchParams: {},
            loading: true,
        };
    };

    render() {
        return (
            <div className={"app"}>
                <div className={"app-wrapper"}>
                    <Switch>
                        <Route exact path={`${process.env.PUBLIC_URL}/`} component={MapLoader} />
                        <Route component={NotFound}/>
                    </Switch>
                </div>
            </div>
        );
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/App.js